module.exports = __webpack_public_path__ + "static/media/badge-pre-register-play-store.84991430.png";